export default "__VITE_ASSET__C5G7DWiO__"